// Copyright 2025, University of Maryland, All Rights Reserved
/**
 * NodeLabelEditor - Reusable component for editing any node's instance label
 *
 * Used across all workflow nodes to provide consistent instance naming.
 * Examples: "Exams", "Finals", "Contract Uploads", "Quick Review"
 */

import React from 'react';
import { Input, Label } from '@/components/ui';

interface NodeLabelEditorProps {
    label: string | undefined;
    onChange: (label: string) => void;
    placeholder?: string;
}

export const NodeLabelEditor: React.FC<NodeLabelEditorProps> = ({
    label,
    onChange,
    placeholder = "e.g., Exams, Finals, Contract Uploads"
}) => {
    return (
        <div className="space-y-2">
            <Label htmlFor="node-label" className="text-sm font-medium text-slate-900">
                Instance Name
            </Label>
            <Input
                id="node-label"
                type="text"
                value={label || ''}
                onChange={(e) => onChange(e.target.value)}
                onKeyDown={(e) => e.stopPropagation()}  // Prevent React Flow from capturing key events
                placeholder={placeholder}
                className="w-full"
            />
            <p className="text-xs text-slate-400">
                Give this instance a meaningful name to distinguish it from other nodes of the same type
            </p>
        </div>
    );
};
